import React from 'react';
import styles from './MessageListHeader.module.scss';
import GenCheckbox from './GenCheckbox';
import {SORTBY_MSGID} from './../AppConstants';

const MessageListHeader = (props) => {
    let chk = props.lastCheck || false;
    if (props.showClosed) chk = false;
    const [cbcheck,setCbCheck] = React.useState(chk);

    const cbCallback = (e) => {
        if (props.showClosed) return false;
        props.allCallback(!cbcheck);
        setCbCheck(!cbcheck);
    }

    const callback = props.cbCallback || cbCallback;
    const fsize = props.globals.intext===1 ? "14px" : "18px";
    const status_column = props.defsortby === SORTBY_MSGID ? 'Message ID' : 'Status';
    return (
        <div className={styles.listheader} style={{fontSize:fsize}}>
            {!props.noCheck && <div><GenCheckbox cbCallback={callback} cbid={0} checked={cbcheck} disabled={props.showClosed || false} /></div>}
            {props.noCheck && <div>&nbsp;</div>}
            <div>Date</div>
            <div>Time</div>
            <div>Patient Name</div>
            <div>{status_column}</div>
            <div>Type</div>
            <div>Caller</div>
            <div>Provider</div>
            {props.globals.intext===1 && <div>Practice</div>}
            <div>Details</div>
            
        </div>
    )

}

export default MessageListHeader;